export default {
      id: "share-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#share-usage",
      toString: function () {
        return this.url;
      }
    }